import type { DefaultVideoType } from '@/core/features/video/video-type';

export const isVideo = (video: unknown): video is DefaultVideoType => {
    return !!(video as DefaultVideoType)?.videoUrl;
};
